import { usePathname } from 'next/navigation'
import { useEffect } from 'react'
import { useSetRecoilState } from 'recoil'

import * as authAtoms from 'src/atoms/auth'

const LOGIN_PATH = '/login'
const SIGN_UP_PATH = '/sign-up'

export const useAuthModal = () => {
  const pathName = usePathname()
  const setAuthModalOpen = useSetRecoilState(authAtoms.modalOpen)
  const setModalState = useSetRecoilState(authAtoms.modalState)

  useEffect(() => {
    switch (pathName) {
      case LOGIN_PATH:
        setAuthModalOpen(true)
        setModalState('login')
        break
      case SIGN_UP_PATH:
        setAuthModalOpen(true)
        setModalState('signup')
        break
      default:
        setAuthModalOpen(false)
    }
  }, [pathName])
}
